module.exports = __webpack_public_path__ + "img/bg-empty.28d10216.png";